import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { withProviders } from '../../../contexts/main/withProviders';
import { ISinglePaymentPageProps } from './interfaces';
import { withChallengeData } from '../../../contexts/storage-contexts/Challenge';
import { withGeneralData } from '../../../contexts/GeneralDataProvider/withGeneralData';
import { withUser } from '../../../contexts/User/withUser';
import { withLocation } from '../../../contexts/Location/withLocation';

import { classes } from './Widget.st.css';
import { PaymentPageV1 } from './PaymentPageV1';
import { Spinner, TPAComponentsProvider } from '@wix/wix-ui-tpa/cssVars';

export const PaymentPage = (props: ISinglePaymentPageProps) => {
  const { isForcedBlankPage = false } = props;
  const { isMobile, isRTL } = useEnvironment();

  if (isForcedBlankPage) {
    return (
      <div className={classes.loader}>
        <Spinner diameter={50} />
      </div>
    );
  }

  return (
    <TPAComponentsProvider value={{ mobile: isMobile, rtl: isRTL }}>
      <PaymentPageV1 {...props} />
    </TPAComponentsProvider>
  );
};

export default withProviders(
  withUser(withGeneralData(withLocation(withChallengeData(PaymentPage)))),
);
